export class ClipboardUtil {

    static parseNumber(raw: string): number | null {
        let s = raw.trim();
        if (!s) {
            return null;
        }
        // Strip trailing % or x suffix
        s = s.replace(/[%x]$/i, "").trim();
        // Detect European format: dots as thousands with optional comma decimal (e.g. "1.234,56")
        // or simple comma decimal with 1-2 digits (e.g. "5,5") — NOT "1,234" (thousand separator)
        if (/^\d{1,3}(\.\d{3})+(,\d+)?$/.test(s) || /^\d+,\d{1,2}$/.test(s)) {
            s = s.replace(/\./g, "").replace(",", ".");
        }
        // Strip remaining thousand separators (commas, spaces, apostrophes)
        s = s.replace(/[,\s']/g, "");
        const num = Number(s);
        return isFinite(num) ? num : null;
    }
}
